import { render, staticRenderFns } from "./award-icon.vue?vue&type=template&id=cdc7e480"
import script from "./award-icon.vue?vue&type=script&lang=js"
export * from "./award-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports